/**
 * @generated SignedSource<<1369dd38d0661ee7869f208cd6090506>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type abandonedCartOfferDialogArticle$data = {
  readonly sections: ReadonlyArray<{
    readonly value: ReadonlyArray<{
      readonly name: string;
    } | null | undefined> | null | undefined;
  } | null | undefined> | null | undefined;
  readonly topics: ReadonlyArray<{
    readonly name: string;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "abandonedCartOfferDialogArticle";
};
export type abandonedCartOfferDialogArticle$key = {
  readonly " $data"?: abandonedCartOfferDialogArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"abandonedCartOfferDialogArticle">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "abandonedCartOfferDialogArticle"
};

(node as any).hash = "da8f28759f9a59422e3d31718ca11247";

export default node;
